import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../common/type';
import { Button } from '../../../components/Button';
import { Field } from '../../../components/Control/Field';
import { Label } from '../../../components/Control/Label';
import { Select } from '../../../components/Control/Select';
import { ICustomer, selectCustomers } from '../../customers';
import { adsCheckoutActionCreator } from '../parts/ads-checkout-action';
import { selectCustomerId } from '../parts/ads-checkout-selector';
import { CheckoutScreen } from '../parts/ads-checkout-type';

const AdsUserSelectionContainer: React.SFC<IProps> = props => (
  <main className="page">
    <h1>Select Your Identity</h1>
    <div>
      <Field fieldId="customer">
        <Label>Customer</Label>
        <Select value={props.customerId} onChangeValue={props.invokeSetCustomerId}>
          {props.customers.map(customer => (
            <option value={customer.id} key={customer.id}>
              {customer.name}
            </option>
          ))}
        </Select>
      </Field>
      <Button onClick={props.invokeNext} primary={true} fullWidth={true}>
        Next
      </Button>
    </div>
  </main>
);

interface IStoreProps {
  customerId: string;
  customers: ICustomer[];
}

interface IDispatchProps {
  invokeSetCustomerId: (customerId: string) => void;
  invokeNext: () => void;
}

type IProps = IStoreProps & IDispatchProps;

const mapStates = (state: IStore): IStoreProps => ({
  customerId: selectCustomerId(state),
  customers: selectCustomers(state)
});

const mapDispatch = (dispatch: Dispatch): IDispatchProps => ({
  invokeSetCustomerId: customerId => dispatch(adsCheckoutActionCreator.SetCustomerId(customerId)),
  invokeNext: () => dispatch(adsCheckoutActionCreator.SetScreen(CheckoutScreen.selection))
});

export const AdsUserSelection = connect(
  mapStates,
  mapDispatch
)(AdsUserSelectionContainer);



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/components/AdsUserSelection.tsx